import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { useExternalData } from "../../utils/ApiContext";
import { BASEURL } from "../../utils/Variables";

const DATA_FILE_PATH = "/uploads/data.json"; 
const PLAYABLE_THUMBNAIL_PATH = BASEURL; 

const CARD_WIDTH = 150;
const GAP_SIZE = 40; 

const slugify = (text) => {
    return text
        .toLowerCase()
        .trim()
        .replace(/&/g, 'and')
        .replace(/[^\w\s-]/g, '')
        .replace(/[\s_-]+/g, '-')
        .replace(/^-+|-+$/g, '');
};

const unslugifyAndCapitalize = (slug) => {
    const words = slug.split('-');
    const capitalized = words.map(word => {
        if (word === 'and') return '&';
        return word.charAt(0).toUpperCase() + word.slice(1);
    }).join(' ');
    
    if (capitalized.includes(' & ')) {
        return capitalized.replace(' & ', ' & ');
    }
    return capitalized;
};

export default function CategoryPlayablesPage() {
    const { categorySlug } = useParams(); 
    const [playables, setPlayables] = useState([]);
    const [categoryInfo, setCategoryInfo] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const { apiData: data, loading, apiError } = useExternalData()

    useEffect(() => {
        if(!data) return;
        setIsLoading(true);
        setError(null);

        console.log("Iopex",data)
        fetch(data)
            // .then(response => {
            //     if (!response.ok) {
            //         throw new Error(`Failed to fetch data: ${response.statusText}`);
            //     }
            //     return response.json();
            // })
            // .then(data => {
            //     const targetCategory = data.Categories.find(
            //         (cat) => slugify(cat.name) === categorySlug
            //     );

            //     if (!targetCategory) {
            //         setError("Category not found.");
            //         setCategoryInfo(null);
            //         return;
            //     }
            //     setCategoryInfo(targetCategory);

            //     const filteredPlayables = data.Playables.filter(
            //         (playable) => playable.categoryID === targetCategory.categoryID
            //     );
            //     setPlayables(filteredPlayables);
                
            // })
            // .catch(err => {
            //     console.error("Error loading data:", err);
            //     setError("Failed to load category data.");
            // })
            // .finally(() => {
            //     setIsLoading(false);
            // });

            try{
                const targetCategory = data.gameCategories.find(
                    (cat) => slugify(cat.name) === categorySlug
                );

                if (!targetCategory) {
                    setError("Category not found.");
                    setCategoryInfo(null);
                    return;
                }
                setCategoryInfo(targetCategory);

                const filteredPlayables = data.staticPlayables.filter(
                    (playable) => playable.gameCategoryId._id === targetCategory._id
                );
                setPlayables(filteredPlayables);
            }catch (err) {
                console.error("Error loading data:", err);
                setError("Failed to load category data.");
            } finally {
                setIsLoading(false);
            }
    }, [categorySlug,data]);

    if (isLoading) {
        return <p className="text-center p-20 min-h-screen bg-white">Loading playables...</p>;
    }

    if (error || !categoryInfo) {
        return <p className="text-center p-20 min-h-screen bg-white text-red-600 text-xl">{error || "Category data not available."}</p>;
    }

    const fiveCardWidth = `${(5 * CARD_WIDTH) + (4 * GAP_SIZE)}px`;
    const categoryName = categoryInfo.name;
    
    const bannerTitle = categoryName;
    const descriptionText = `Explore all playables in the ${categoryName} category.`;
    
    const bannerImagePath = "/uploads/placeholder-banner.png"; 

    return (
        <div className="min-h-screen bg-white">
            <section className="relative w-full overflow-hidden bg-black min-h-[300px] flex items-center justify-center">
                <div className="absolute inset-0 bg-black opacity-50"></div>

                <div className="relative mx-auto max-w-10xl p-16 px-4 sm:px-6 z-10 text-center text-white">
                    <h1 className="font-uber text-[36px] font-bold leading-[44px] mb-4">
                        {bannerTitle}
                    </h1>
                    <p className="mt-2 font-uber text-[16px] font-normal leading-[24px] max-w-4xl mx-auto">
                        {descriptionText}
                    </p>
                </div>
            </section>
            
            <section className="relative w-full overflow-hidden">
                <div className="mx-auto max-w-6xl p-20 px-4 sm:px-6">
                    <div 
                        className="mx-auto flex flex-wrap justify-center gap-10"
                        style={{ maxWidth: fiveCardWidth }}
                    >
                        
                        {playables.length > 0 ? (
                            playables.map((playableItem, index) => {
                                const assetPath = `${PLAYABLE_THUMBNAIL_PATH}${playableItem.thumbnailPath}`;
                                
                                const linkTo = `/playable/${playableItem._id}?cf=gc`; 
                                console.log("CATEGORY_PLAYABLE_PAGE")
                                return (
                                    <Link 
                                        to={linkTo} 
                                        key={index} 
                                        className="w-full max-w-[150px] flex-shrink-0" 
                                    >
                                        <img
                                            src={assetPath}
                                            alt={playableItem.name}
                                            className="w-full h-auto object-cover rounded-lg shadow-lg"
                                            onError={(e) => {
                                                e.target.onerror = null; 
                                                e.target.src = "/placeholder-image.png"; 
                                            }}
                                        />
                                    </Link>
                                );
                            })
                        ) : (
                            <p className="text-center text-xl text-gray-500 w-full">
                                No playables found for the {categoryName} category.
                            </p>
                        )}
                    </div>
                </div>
            </section>
        </div>
    );
}